import AssociationAccount from './AssociationAccount.page';

export default AssociationAccount;